
import axios from "axios";

/* =========================
   BASE URL
========================= */

const LOCAL_API = "http://localhost:5000";

const LIVE_API = "https://hrms.morganjob.com";


axios.defaults.withCredentials = false;

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const serverURL = isLocalhost ? LOCAL_API : LIVE_API;
// console.log("SERVER URL =", serverURL);

/* =========================
   FORCE LOGOUT
========================= */
const forceLogout = async () => {
  try {
    const user = JSON.parse(localStorage.getItem("USER"));
    if (user?.id) {
      await axios.post(`${serverURL}/attendances/logout`, {
        user_id: user.id,
      });
    }
  } catch (err) {
    console.error("Force Logout API Error:", err);
  } finally {
    localStorage.removeItem("TOKEN");
    localStorage.removeItem("USER");
  }
};

/* =========================
   HEADERS
========================= */
const getHeaders = () => {
  const token = localStorage.getItem("TOKEN");
  const userId = localStorage.getItem("user_id");
  const headers = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (userId) headers["user_id"] = userId;

  const admin = localStorage.getItem("ADMIN");
  if (admin) {
    headers["is_admin"] = "true";
    const adminObj = JSON.parse(admin);
    if (adminObj && adminObj.id) {
      headers["user_id"] = adminObj.id;
    }
  }
  return headers;
};

/* =========================
   CLEAN URL
========================= */
const cleanUrl = (url) => {
  return url.startsWith("/") ? url.slice(1) : url;
};

/* =========================
   POST API
========================= */
const postData = async (url, body, config = {}) => {
  try {
    let headers = { ...getHeaders() };

    if (!(body instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    const response = await axios.post(
      `${serverURL}/${cleanUrl(url)}`,
      body,
      {
        headers,
        withCredentials: true,
        ...config,
      }
    );

    return response.data;
  } catch (error) {
    console.error("POST Error:", error);

    if (error.response?.data) {
      return error.response.data;
    }

    return {
      status: false,
      message: "Network error. Please try again.",
    };
  }
};

/* =========================
   GET API
========================= */
const getData = async (url) => {
  try {
    const response = await axios.get(`${serverURL}/${cleanUrl(url)}`, {
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(),
      },
      withCredentials: true,
    });

    return response.data;
  } catch (e) {
    console.error("API GET Error:", e);

    if (e.response?.status === 401 || e.response?.status === 403) {
      await forceLogout();
      return { status: false, message: "Unauthorized Access" };
    }

    return {
      status: false,
      message: "Server Error, please contact Backend team",
    };
  }
};

/* =========================
   PUT API
========================= */
const putData = async (url, body) => {
  try {
    const response = await axios.put(
      `${serverURL}/${cleanUrl(url)}`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(),
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    console.error("API PUT Error:", e);

    if (e.response?.status === 401 || e.response?.status === 403) {
      await forceLogout();
    }

    return {
      status: false,
      message: e.response?.data?.message || "Server Error",
    };
  }
};

/* =========================
   DELETE API
========================= */
const deleteData = async (url) => {
  try {
    const response = await axios.delete(
      `${serverURL}/${cleanUrl(url)}`,
      {
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(),
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    console.error("API DELETE Error:", e);

    if (e.response?.status === 401 || e.response?.status === 403) {
      await forceLogout();
    }

    return {
      status: false,
      message: e.response?.data?.message || "Server Error",
    };
  }
};

/* =========================
   EXPORTS
========================= */
export { postData, getData, putData, deleteData };
